require('bower/nprogress/nprogress.css');
require('noty');

var app = require('system.app'),
        dialog = require('app/shared/helper/dialog'),
        nprogress = require('nprogress');

app.config.loaderFunction = [
    function ($container) {
        //$container.addClass('loading').prepend('<div class="fill"></div><div class="spinner"></div>');

    },
    function ($container) {
        //$container.removeClass('loading').find('.fill .spinner').remove();
    }
];

app.loader = {
    display: function ($container) {
        if (app.config.loaderFunction.length > 0) {
            //app.config.loaderFunction[0]($container);
            nprogress.start();
        } else {
            //$container.addClass(app.config.loaderClass);
        }
    },
    hide: function ($container) {
        /*if (app.config.loaderFunction.length > 0) {
         app.config.loaderFunction[1]($container);
         }
         else {
         $container.removeClass(app.config.loaderClass);
         }*/
        setTimeout(function () {
            nprogress.done();
        }, 300);
    }
};

app.message = {
    _display: function (text, type) {
        var notes = [];

        notes['alert'] = text;
        notes['danger'] = '<i class="fa fa-fw fa-times fs-16 mr-5"></i>' + text;
        notes['success'] = '<i class="fa fa-fw fa-check fs-16 mr-5"></i>' + text;
        notes['info'] = '<i class="fa fa-fw fa-info fs-16 mr-5"></i>' + text;
        notes['warning'] = '<i class="fa fa-fw fa-warning fs-16 mr-5"></i>' + text;



        noty({
            layout: 'topCenter',
            type: type,
            text: notes[type],
            theme: 'defaultTheme',
            timeout: 3000,
            progressBar: true,
            maxVisible: 3,
            animation: {
                open: 'animated zoomIn anim3x',
                close: 'animated zoomOut anim5x'
            }
        });
    },
    error: function (text) {
        this._display(text, 'danger');
    },
    success: function (text) {
        this._display(text, 'success');
    },
    warning: function (text) {
        this._display(text, 'warning');
    },
    info: function (text) {
        this._display(text, 'info');
    },
    /**
     * Display confirm message
     * 
     * @param {string} text text to display
     * @returns $.Deferred()
     */
    confirm: function (text) {
        var d = $.Deferred();

        noty({
            layout: 'center',
            type: 'white',
            theme: 'noty-default noty-confirm',
            text: text,
            maxVisible: 1,
            buttons: [
                {
                    addClass: 'btn btn-sm btn-success mr-5', text: 'Áno', onClick: function ($noty) {
                        // this = button element
                        // $noty = $noty element
                        $noty.close();

                        d.resolve();
                    }
                },
                {
                    addClass: 'btn btn-sm btn-danger', text: 'Nie', onClick: function ($noty) {
                        $noty.close();

                        d.reject(false);
                    }
                }
            ],
            animation: {
                open: 'animated flipInX anim5x',
                close: 'animated flipOutX anim5x'
            }
        });

        return d.promise();
    },
}

app.showDialog = function (url) {
    dialog.show(url, null);
}